import React from 'react';
import ABEII from '../../images/abeii.jpg';
import {
    AssoContainer,
    AssoH1,
    AssoWrapper,
    AssoPicture,
    Img
} from './AssociationElements';

const association = () => {
    return (
        <AssoContainer id="association" className="darkBackground">
            <AssoH1 className="lightColor">ABEII - 2020/2021</AssoH1>
            <AssoPicture>
                <Img src={ABEII} alt="Picture of the ABEII" />
            </AssoPicture>
        </AssoContainer>
    )
}

export default association